import { render, staticRenderFns } from "./act-item.vue?vue&type=template&id=04d5dda3&scoped=true&"
import script from "./act-item.vue?vue&type=script&lang=js&"
export * from "./act-item.vue?vue&type=script&lang=js&"
import style0 from "./act-item.vue?vue&type=style&index=0&id=04d5dda3&scoped=true&lang=scss&"
import style1 from "./act-item.vue?vue&type=style&index=1&id=04d5dda3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d5dda3",
  null
  
)

export default component.exports